import countrySpecific from './module';

export default {
  install(Vue) {
    Vue.prototype.$country = countrySpecific;
  }
};
